import { IdentityTypesEnum } from 'services/api-accounts.service';

export const IdentityTypeMap = (identityType?: string) => {
  switch (identityType) {
    case IdentityTypesEnum.icNumber:
      return 'IC Number';
    case IdentityTypesEnum.oldIcNumber:
      return 'Old IC Number';
    case IdentityTypesEnum.passportNumber:
      return 'Passport Number';
    default:
      return '-';
  }
};
